/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import { node, string } from 'prop-types';
import './ActionButton.scss';

import classnames from 'classnames';
import React from 'react';

const ActionButtonLink = ({ children, className, href, type, ...props }) => {
  const buttonClassname = classnames(className, {
    'action-button-link': true,
    'primary-button': type === 'primary',
    'secondary-button': type === 'secondary'
  });

  return (
    <a className={buttonClassname} href={href} {...props}>
      {children}
    </a>
  );
};

ActionButtonLink.propTypes = {
  children: node.isRequired,
  className: string.isRequired,
  href: string.isRequired,
  id: string.isRequired,
  type: string.isRequired
};

ActionButtonLink.defaultProps = {
  className: '',
  type: 'secondary'
};

export default ActionButtonLink;
